<script>
import ContractTab from "../../components/ContractTab.vue";
import WarningInfo from "../../components/WarningInfo.vue";
import { getUserContract, downloadContractFile } from "../../api/user";

export default {
  name: "documentView",
  components: { ContractTab, WarningInfo },
  data() {
    return {
      selectedTab: 1,
      pdfUrl: null,
      contractsReady: false,
    };
  },
  computed: {
    getSrc() {
      return this.selectedTab === 1
        ? "main"
        // : this.selectedTab === 2
        // ? "monetary"
        : "";
    },
    contracts() {
      return this.$store.getters['user/contracts'] || []
    },
    currentContract() {
      return this.contracts.find(c => c.type === this.getSrc)
    },
    // Брокер баталгаажуулаагүй байхад гэрээг харуулахгүй
    waitingBrokerConfirmation() {
      return !!this.currentContract && this.currentContract.status === 'user_signed'
    },
    // admin_signed үед S3-д хадгалагдсан, гарын үсэгтэй файлыг үзүүлнэ
    signedContract() {
      return this.currentContract && this.currentContract.status === 'admin_signed'
        ? this.currentContract
        : null
    },
  },
  watch: {
    getSrc() {
      this.loadPdf();
    },
  },
  async created() {
    // Гэрээний статусаас хамаарч аль файлыг үзүүлэхээ шийддэг тул эхлээд статусаа авна
    try {
      await this.$store.dispatch('user/fetchContracts')
    } finally {
      this.contractsReady = true
      this.loadPdf()
    }
  },
  beforeDestroy() {
    if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
  },
  methods: {
    async loadPdf() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
        this.pdfUrl = null;
      }
      if (!this.contractsReady || !this.getSrc || this.waitingBrokerConfirmation) return;
      try {
        const response = this.signedContract
          ? await downloadContractFile(this.signedContract.id)
          : await getUserContract(this.getSrc);
        const blob = new Blob([response.data], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error(e);
      }
    },
    selectTab(val) {
      this.selectedTab = val;
    },
  },
};
</script>

<template>
  <div>
    <div class="row tabs">
      <ContractTab
        class="col"
        :text="$t('contract.brokerage')"
        :index="1"
        @selectTab="selectTab"
        :active="selectedTab === 1"
      />
      <!-- <ContractTab
        class="col"
        :text="$t('contract.cash')"
        :index="2"
        @selectTab="selectTab"
        :active="selectedTab === 2"
      /> -->
    </div>
    <div class="tab-content">
      <warning-info
        v-if="waitingBrokerConfirmation"
        class="contract-warning"
        :body="$t('contract.waiting_broker_confirmation')"
      />
      <div v-else class="contract-view">
        <embed
          v-if="pdfUrl"
          style="width: 100%; height: 100%"
          type="application/pdf"
          :src="pdfUrl"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tabs {
  padding-right: 15px;
  padding-left: 15px;
}
.tab-content {
  display: flex;
  justify-content: center;
  padding: 24px;
  background-color: var(--sidebar-background);
  border-radius: 0 0 20px 20px;
  border-color: var(--sidebar-background);
}
.contract-view {
  background-color: white;
  width: 70%;
  height: 80vh;
  box-shadow: 0 0 10px -7px var(--text-primary-color);
}
.contract-warning {
  width: 70%;
}
</style>
